import React from 'react'

const QuickStats = ({quick_stats}) => {
  return (

       

            <div className="card  shadow-sm p-4" dir="rtl" style={{borderRadius:"20px"}}>
  <h5 className="fw-bold mb-4">إحصائيات سريعة</h5>

  <div className="row mb-3 align-items-center">
    <div className="col fw-semibold text-secondary">معدل النجاح</div>
    <div className="col-auto fw-bold text-success">{quick_stats?.success_rate_formatted}</div>

    <div className="col-12 mt-2">
      <div className="progress" style={{height:"8px",background: "#e6e6e6"}}>
        <div className="progress-bar bg-success" style={{width:`${quick_stats?.success_rate}`}}></div>
      </div>
    </div>
  </div>


  <div className="row mb-3 align-items-center">
    <div className="col fw-semibold text-secondary">متوسط الطلبات/اليوم</div>
    <div className="col-auto fw-bold">{quick_stats?.avg_orders_per_day_formatted}</div>
  </div>


  <div className="row mb-3 align-items-center">
    <div className="col fw-semibold text-secondary">متوسط الأرباح/اليوم</div>
    <div className="col-auto fw-bold text-success"> {quick_stats?.avg_revenue_per_day_formatted}</div>
  </div>


  <div className="row align-items-center">
    <div className="col fw-semibold text-secondary">التقييم العام</div>
    <div className="col-auto fw-bold">{quick_stats?.average_rating_formatted} ⭐</div>
  </div>
</div>

  )
}

export default QuickStats